import { IconProps } from "@/data/types"

export default function SwimmingIcon({ width=36, height=36, color='#000000', className }: IconProps) {
  return (
    <div className={className}>
      <svg width={width} height={height} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" strokeWidth="1.92" stroke={color} fill="none">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"/>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"/>
      <g id="SVGRepo_iconCarrier">
      <path d="M39,34,31.05,23.52l-2-2.59-3.88-5.22L22,18.15,14.66,23.9a2.28,2.28,0,0,0,0,3.11c1.14,1.19,2.46,1.33,3.17.78l6.33-5.37,3.21,3.95-8.9,6.94" strokeLinecap="square"/>
      <circle cx="42.38" cy="21.91" r="6.1" strokeLinecap="square"/>
      <path d="M4.79,41.15c3.89,0,3.89,4,7.77,4s3.89-4,7.77-4,3.89,4,7.77,4,3.89-4,7.78-4,3.89,4,7.77,4,3.89-4,7.78-4,3.89,4,7.78,4" strokeLinecap="square"/>
      <path d="M4.79,33.06c3.89,0,3.89,4,7.77,4s3.89-4,7.77-4,3.89,4,7.77,4,3.89-4,7.78-4,3.89,4,7.77,4,3.89-4,7.78-4,3.89,4,7.78,4" strokeLinecap="square"/>
      </g>
      </svg>
    </div>
  )
}